import { useAppVersionCheck } from "@common/composables/utility/app-version-check"
import { initializeVersionReload } from "@common/services/version-reload-service"
import { createRouter, createWebHistory } from "vue-router"

import { dashboardRoutes } from "@/router/routes/dashboard-routes"

import { routes as loginAuthRoutes } from "@/modules/login/router/routes"
import { routes as setupAuthRoutes } from "@/modules/setup/router/routes"
import { routes as occupationalHealthRoutes } from "@/modules/occupational-health/router/routes"
import { routes as clinicCheckInRoutes } from "@/modules/clinic-checkin/router/routes"

import embedRoutes from "@/modules/embed/router/routes"
import { routes as onboardingRoutes } from "@/modules/onboarding/router/routes"
import { routes as quotingRoutes } from "@/modules/quoting/router/routes"
import { noLayoutRoutes as benefitsNoLayoutRoutes } from "@/modules/benefits/router/routes"

import analyticsService from "@/services/analytics/analytics-service"
import { createEnsureNotEmbedded } from "@common/router/embed-guards"
import GuardianRunner from "@/router/guardian-runner"

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/:pathMatch(.*)*",
      redirect: { name: "login" }
    },
    ...loginAuthRoutes,
    ...setupAuthRoutes,
    ...embedRoutes,
    ...dashboardRoutes,
    ...clinicCheckInRoutes,
    ...occupationalHealthRoutes,
    ...onboardingRoutes,
    ...quotingRoutes,
    ...benefitsNoLayoutRoutes
  ],
  scrollBehavior(to, _from, _savedPosition) {
    if (to.hash) {
      document!.getElementById(to.hash.replace("#", ""))!.scrollIntoView({ behavior: "smooth" })
    } else {
      const dashboardEl = document.getElementById("content")
      if (dashboardEl) {
        dashboardEl.scrollTo(0, 0)
      } else {
        window.scrollTo(0, 0)
      }
    }
  }
})

router.beforeEach(createEnsureNotEmbedded(() => router, "embed-employer-benefits"))

router.afterEach((to, from) => {
  analyticsService.pageViewed({
    name: to.name,
    path: to.path,
    from_name: from ? from.name : null,
    from_path: from ? from.path : null
  })
})

GuardianRunner.init({
  globalGuardians: []
})

const { newVersionAvailable } = useAppVersionCheck()
initializeVersionReload(router, newVersionAvailable)

export default router
